import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword } from '../../actions/sessions';
import { Field, reduxForm } from 'redux-form';
import CONSTANTS from '../../constants'

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = { old_password: '', new_password: '', password_confirmation: '' }
    }

    renderField(field) {
        let hasError = field.meta.touched && field.meta.error;
        return (
            <div className="form-group">
                <div className="input-group">
                    <span className="input-group-addon is-invalid"><i className={field.icon}></i></span>
                    <input {...field.input}  className={`form-control ${hasError ? 'is-invalid' : ''}`} type={field.type}
                           placeholder={field.placeholder} />
                </div>
                <div className="invalid-feedback">
                    { hasError ? field.meta.error : ''}
                </div>
            </div>
        )
    }

    onSubmit(values) {
        this.props.changePassword(values.old_password, values.new_password, values.password_confirmation, this.props.history);
    }

    render () {
        const { handleSubmit } = this.props;
        return (
            <div className="flex-center">
                <div className="content-card col-lg-6 col-xs-12">
                    <h1>{CONSTANTS.APP_TITLE}</h1>
                    <p className="text-muted">Change your password</p>
                    <form className="members-area-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                        <Field
                            name="old_password"
                            type="password"
                            placeholder="Old password"
                            className="form-control"
                            icon="fas fa-key"
                            value={this.state.old_password}
                            component={this.renderField}
                        />

                        <Field
                            name="new_password"
                            type="password"
                            placeholder="New password"
                            className="form-control"
                            icon="fas fa-key"
                            value={this.state.new_password}
                            component={this.renderField}
                        />

                        <Field
                            name="password_confirmation"
                            type="password"
                            placeholder="Confirm password"
                            className="form-control"
                            icon="fas fa-key"
                            value={this.state.password_confirmation}
                            component={this.renderField}
                        />
                        <button type="submit" className="btn btn-lg btn-primary full-width">Change Password</button>
                    </form>
                </div>
            </div>
        );
    }
}

function validate(values) {
    let errors = {};

    if(!values.old_password)
        errors.old_password = 'Please enter old password here';
    if(!values.new_password)
        errors.new_password = 'Please enter new password here';
    if(!values.password_confirmation)
        errors.password_confirmation = 'Please confirm your new password here';
    if(values.new_password !== values.password_confirmation)
        errors.password_confirmation = 'Passwords do not match';
    return errors;
}

export default reduxForm({validate: validate, form: 'changePasswordForm'})(connect(null, { changePassword })(ChangePassword));
